import { App } from "@/constants";
import { ProductIdFromSdkProvider } from "@lib/ProductIdManager/ProductIdFromSdkProvider";
import { ProductVariantIdFromSdkProvider } from "@lib/ProductVariantIdManager/ProductVariantIdFromSdkProvider";
import AnalyticsEventsCollectorInterface from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsCollectorInterface";
import {
    combineLatest,
    map,
    Observable,
    of,
    switchMap,
    tap,
    filter,
    take,
    takeUntil,
    distinctUntilChanged,
    debounceTime,
    throttleTime,
    catchError,
    retry,
    merge,
    forkJoin,
} from "rxjs";

import SdkAnalyticsEventsFactory from "../analytics/SdkAnalyticsEventsFactory";
import { SDK_MODULES } from "../constants";
import Sdk from "../Sdk";
import { SdkRegisteredModuleInterface } from "../SdkRegisteredModuleInterface";
import CommonSdkEvents from "./CommonSdkEvents";
import CommonSdkMethods from "./CommonSdkMethods";

class CommonSdk implements SdkRegisteredModuleInterface {
    public readonly events: CommonSdkEvents;

    public readonly methods: CommonSdkMethods;

    public readonly rxjs = {
        // Creation operators
        of,
        // Transformation operators
        map,
        switchMap,
        // Filtering operators
        filter,
        take,
        takeUntil,
        distinctUntilChanged,
        debounceTime,
        throttleTime,
        // Combination operators
        combineLatest,
        merge,
        forkJoin,
        // Utility operators
        tap,
        // Error handling operators
        catchError,
        retry,
    };

    public readonly constants = {
        apps: {
            INSTAGRAM: App.Instagram,
            SOCIAL_LOGIN: App.Login,
            QUESTIONS: App.Questions,
            REVIEWS: App.Reviews,
            REWARDS: App.Rewards,
            TIKTOK: App.TikTok,
            WISHLISTS: App.Wishlist,
            GIFT_REGISTRY: App.GiftRegistry,
        },
        modules: {
            AUTHENTICATION: SDK_MODULES.AUTHENTICATION,
            PRODUCTS: SDK_MODULES.PRODUCTS,
            REVIEWS: SDK_MODULES.REVIEWS,
            REWARDS: SDK_MODULES.REWARDS,
            WISHLISTS: SDK_MODULES.WISHLISTS,
            CART: SDK_MODULES.CART,
            DISCOUNTS: SDK_MODULES.DISCOUNTS,
            GIFT_REGISTRY: SDK_MODULES.GIFT_REGISTRY,
        },
    };

    constructor(
        sdk: Sdk,
        productIdProvider: ProductIdFromSdkProvider,
        variantIdProvider: ProductVariantIdFromSdkProvider,
        eventsCollector: AnalyticsEventsCollectorInterface,
        eventsFactory: SdkAnalyticsEventsFactory,
        isEventsSenderStarted$: Observable<boolean>
    ) {
        this.events = new CommonSdkEvents(
            sdk,
            eventsCollector,
            eventsFactory,
            isEventsSenderStarted$
        );

        this.methods = new CommonSdkMethods(
            productIdProvider,
            variantIdProvider
        );
    }

    public register(sdk: Sdk & { common?: CommonSdk }) {
        sdk.common = this;
    }
}

export default CommonSdk;
